let navs = document.getElementsByClassName("profile-nav");
for(let i = 0; i < navs.length; i++){
    navs[i].textContent=" ";
}